const API_URL = "https://app.tavad.com/hce/wp-json/wp/v2";

export async function getAllPacientes() {
  const authToken = sessionStorage.getItem( 'token' );
  try {
    const response = await fetch(`${API_URL}/users?roles=subscriber&orderby=id&order=desc&per_page=50`, {
      method: 'GET',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${ authToken }`,
      },
    } );
    const data = await response.json();
    if (data.code === "jwt_auth_invalid_token") {
      window.location.replace(
        '/login'
      );
    }
    return data;
  } catch (error) {
    console.error(error);
    
  }
}

export async function getPacienteByID(pacienteId) {
  const authToken = sessionStorage.getItem( 'token' );
  try {
    const response = await fetch(`${API_URL}/users/${pacienteId}`, {
      method: 'GET',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${ authToken }`,
      },
    } );
    const data = await response.json();
    if (data.code === "jwt_auth_invalid_token") {
      window.location.replace(
        '/login'
      );
    }
    return data;
  } catch (error) {
    console.error(error);
  }
}

export async function getSearchPacientes(pacienteQuery) {
  const authToken = sessionStorage.getItem( 'token' );
  try {
    const response = await fetch(`https://app.tavad.com/hce/wp-json/tavad/v2/pacientes?&search=${pacienteQuery}`, {
      method: 'GET',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${ authToken }`,
      },
    } );
    const data = await response.json();
    if (data.code === "jwt_auth_invalid_token") {
      window.location.replace(
        '/login'
      );
    }
    return data;
  } catch (error) {
    console.error(error);
  }
}

export async function getSearchPacientesByEspecialista(pacienteQuery, especialistaId) {
  const authToken = sessionStorage.getItem( 'token' );
  try {
    const response = await fetch(`https://app.tavad.com/hce/wp-json/tavad/v2/pacientes?&especialista=${especialistaId}&search=${pacienteQuery}`, {
      method: 'GET',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${ authToken }`,
      },
    } );
    const data = await response.json();
    if (data.code === "jwt_auth_invalid_token") {
      window.location.replace(
        '/login'
      );
    }
    return data;
  } catch (error) {
    console.error(error);
  }
}

export async function getPacientesByEspecialista(especialistaId) {
  const authToken = sessionStorage.getItem( 'token' );
  try {
    const response = await fetch(`https://app.tavad.com/hce/wp-json/tavad/v2/pacientes?roles=subscriber&orderby=id&order=desc&per_page=50&especialista=${especialistaId}`, {
      method: 'GET',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${ authToken }`,
      },
    } );
    const data = await response.json();
    if (data.code === "jwt_auth_invalid_token") {
      window.location.replace(
        '/login'
      );
    }
    return data;
  } catch (error) {
    console.error(error);
  }
}

export async function getLastPacientes() {
  const authToken = sessionStorage.getItem( 'token' );
  try {
    const response = await fetch(`${API_URL}/users?roles=subscriber&orderby=id&order=desc&per_page=20`, {
      method: 'GET',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${ authToken }`,
      },
    } );
    const data = await response.json();
    if (data.code === "jwt_auth_invalid_token") {
      window.location.replace(
        '/login'
      );
    }
    return data;
  } catch (error) {
    console.error(error);
  }
}

export async function sendResetPasswordEmail(userID) {
  const authToken = sessionStorage.getItem('token');
  try {
    const response = await fetch(`https://app.tavad.com/hce/wp-json/tavad/v2/reenviar-bienvenida`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${authToken}`,
      },
      body: JSON.stringify({ userID }), // Envía solo el userID en el cuerpo
    });

    const data = await response.json();

    if (data.code === "jwt_auth_invalid_token") {
      window.location.replace('/login');
    }
    
    return data; // Devuelve la respuesta de la API
  } catch (error) {
    console.error(error);
  }
}
